import {
    namespace,
    reducer,
    selectors,
} from './base';
import * as operations from './operations';

const confirmPasswordAction = {
    ...operations,
    ...selectors,
};

export {
    confirmPasswordAction,
};
export default {
    [namespace]: reducer,
};
